import actionTypes from "./actionTypes";
import api from "./api";
import { error } from "App/popupMessage";
import locale from "./actionCreators.locale";
export default {
    getObjects: () => ({
        type: actionTypes.GET_OBJECTS,
        payload: { promise: () => api.getObjects() },
        rejected: (dispatch) => {
            dispatch(error(locale.GET_OBJECTS_FAILED));
        }
    }),
    getMethods: () => ({
        type: actionTypes.GET_METHODS,
        payload: { promise: () => api.getMethods() },
        rejected: (dispatch) => {
            dispatch(error(locale.GET_METHODS_FAILED));
        }
    })
};
